/**
 * @prettier
 */

import { extendTheme, ThemeConfig } from "@chakra-ui/react";

const companylight: Record<string, string> = {
  perfusionpurple: "#581F6B",
  brainblue: "#103753",
  codegreen: "#49AD42",
};

const theme = extendTheme({
  initialColorMode: "system",
  useSystemColorMode: true,
  colors: {
    primary: { dark: "black", light: companylight.perfusionpurple },
    secondary: { dark: companylight.codegreen, light: "white" },
    text: { dark: "white", light: "white" },
    perfusionpurple: companylight.perfusionpurple,
    brainblue: companylight.brainblue,
    lightbrainblue: "#298ed6",
    // Custom bexorg color scheme with perfusion purple
    bexorg: {
      50: "#F4F0F6",
      100: "#E1D4E6",
      200: "#CDB8D7",
      300: "#B89CC7",
      400: "#A480B8",
      500: "#581F6B", // Base perfusion purple
      600: "#4A1A5A",
      700: "#3D1548",
      800: "#2F1037",
      900: "#220B25",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        // Use Chakra's built-in color mode values
        bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
      },
      // Disable transitions only for specific heavy components
      ".ag-theme-alpine, .ag-theme-alpine-dark": {
        transition: "none !important",
      },
      ".rs-calendar": {
        transition: "none !important",
      },
      ".plot-container": {
        transition: "none !important",
      }
    }),
  },
});



export { theme, companylight };
